import React, { useState, useEffect } from "react";
import { object, array, string, bool } from "prop-types";
import { Link } from "@quintype/components";

import CardImage from "../../atoms/CardImage";
import NewsHeadline from "../../atoms/NewsHeadline";
import LiveNewsHeadline from "../../atoms/liveNewsHeadline";
import Excerpt from "../../atoms/Excerpt";

import { getExcerpt } from "../../utils/utils";

import "./wideStoryCard.m.css";

const WideStoryCard = ({
  story,
  widths = [650],
  imageType = "image16x9",
  aspectRatio = [16, 9],
  isCommentedStory = false,
  excerptShow = true,
}) => {
  const excerpt = getExcerpt(story);
  const [isMobile, setIsMobile] = useState(true);
  const showLiveBlog = story["story-template"] === "live-blog";
  useEffect(() => {
    global.deviceWidth > 875 && setIsMobile(!isMobile);
  }, []);

  return (
    <div styleName="base" className="wide-story-card">
      <Link aria-label={story.headline} href={story.url}>
        <CardImage
          story={story}
          aspectRatio={aspectRatio}
          imageType={imageType}
          widths={widths}
          showAlternateImage={true}
          isCommentedStory={isCommentedStory}
        />
      </Link>
      <div styleName="story-data" className="story-data">
        {showLiveBlog ? (
          <LiveNewsHeadline story={story} cssStyleName={isMobile ? "mediumBigSize" : "bigSize"} />
        ) : (
          <NewsHeadline story={story} cssStyleName={isMobile ? "mediumBigSize" : "bigSize"} />
        )}
        {excerptShow && excerpt && <Excerpt excerpt={excerpt} excerptLink={story.url} />}
      </div>
    </div>
  );
};

WideStoryCard.propTypes = {
  story: object.isRequired,
  widths: array,
  imageType: string,
  aspectRatio: array,
  isCommentedStory: bool,
  cssStyleName: string,
  excerptShow: bool,
};

export default WideStoryCard;
